import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import CancelReservationAsDiv from '../CancelReservationAsDiv';
import History from '../History';

class AppointmentManagement extends Component {
  render() {
    const { viaSso } = this.props;
    const manager = viaSso ? <History /> : <CancelReservationAsDiv />;
    return (
      <div>
        {manager}
      </div>
    );
  }
}

AppointmentManagement.propTypes = {
  viaSso: PropTypes.bool.isRequired
};

AppointmentManagement.defaultProps = { };

export default translate(['common', 'booking'], { wait: true })(AppointmentManagement);



// WEBPACK FOOTER //
// ./src/containers/AppointmentManagement/AppointmentManagement.jsx